import {AfterViewInit, ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

import {MapPanelService} from "@map-panel/services/map-panel.service";

import {MinimapService} from "@src/app/map/services/minimap.service";

@Component({
  selector: 'mapm-minimap-controls',
  templateUrl: './minimap-controls.component.html',
})
export class MinimapControlsComponent implements OnInit, AfterViewInit {

  areButtonsVisible = false;

  constructor(
    private mapPanelService: MapPanelService,
    private minimapService: MinimapService,
  ) {
    this.areButtonsVisible = this.minimapService.isMinimapVisible;
  }

  ngAfterViewInit(): void {
    this.minimapService.minimapVisibleChangedSub$.subscribe(visible => {
      this.areButtonsVisible = visible;
    });
  }

  ngOnInit(): void {
  }

  onZoomIn() {
    this.minimapService.zoomIn();
  }

  onZoomOut() {
    this.minimapService.zoomOut();
  }
}
